import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import storyHero from "@/assets/story-hero.webp";

export const StoryPreview = () => {
  return (
    <section className="bg-gradient-to-b from-background to-cream bg-zellige relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute top-1/3 right-0 w-64 h-64 rounded-full bg-primary/5 blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-warm border border-primary/15">
            {/* Cultural flag accents */}
            <div className="absolute top-4 left-4 z-10 flex gap-2">
              <span className="w-9 h-9 rounded-full bg-background/80 backdrop-blur-sm flex items-center justify-center text-lg shadow-sm border border-primary/10 transition-all duration-300 hover:scale-125 hover:-rotate-12 hover:shadow-warm">🇹🇳</span>
              <span className="w-9 h-9 rounded-full bg-background/80 backdrop-blur-sm flex items-center justify-center text-lg shadow-sm border border-primary/10 transition-all duration-300 hover:scale-125 hover:rotate-12 hover:shadow-warm">🍁</span>
            </div>
            <img
              src={storyHero}
              alt="Fusion culturelle Tunisie-Canada"
              className="w-full h-64 md:h-80 object-cover"
              loading="lazy"
              width={960}
              height={400}
            />
          </div>

          {/* Text */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <div className="w-8 h-1 rounded-full bg-gradient-to-r from-primary to-gold" />
              <span className="text-sm font-body uppercase tracking-widest" style={{ backgroundImage: 'linear-gradient(135deg, hsl(18 78% 50%), hsl(42 72% 55%))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Notre Histoire</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-display font-bold leading-tight">
              De la Tunisie au Canada,{" "}
              <span className="text-gradient">avec amour</span>
            </h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              On a quitté notre pays, mais jamais notre culture. Chaque adhésif EL FAZA porte en lui
              la fierté de nos racines tunisiennes et la reconnaissance envers le Canada —
              le pays qui nous a ouvert ses bras.
            </p>
            <Link to="/notre-histoire">
              <Button variant="outline" className="group mt-2 border-primary/20 hover:bg-primary/5 hover:border-primary/40">
                Découvrir notre histoire
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
